import { render, staticRenderFns } from "./PricesPanel.vue?vue&type=template&id=437883f0&scoped=true"
import script from "./PricesPanel.vue?vue&type=script&lang=js"
export * from "./PricesPanel.vue?vue&type=script&lang=js"
import style0 from "./PricesPanel.vue?vue&type=style&index=0&id=437883f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437883f0",
  null
  
)

export default component.exports